// Adattatore verso la configurazione unica degli ambienti (vedi ../env.js).
// Punta al backend gestionale (bk). Per cambiare ambiente modificare env.js.
import env from '../env';

const impostazioni = {
    api_url: env.bk,
}

export default impostazioni;
